import React from 'react'

import { LuListMusic } from '@react-icons/all-files/lu/LuListMusic'

import type { PlaylistResult } from 'types/search-page'

import styles from './playlist-name-cell.module.css'

type Props = {
  artworks: PlaylistResult['tracks_artworks']
  size?: number
}

const getUrl = (
  entry: NonNullable<PlaylistResult['tracks_artworks']>[number],
): string => {
  if (typeof entry === 'string') return entry
  return entry.artwork_sizes?.['160x160'] ?? entry.artwork ?? ''
}

const PlaylistMosaic = ({ artworks, size = 40 }: Props) => {
  const urls = (artworks ?? []).map(getUrl).filter(Boolean)

  const mosaicStyle = { width: size, height: size }
  const fallbackIconSize = Math.round(size * 0.4)

  if (urls.length === 0) {
    return (
      <span className={styles.mosaicFallback} style={mosaicStyle}>
        <LuListMusic size={fallbackIconSize} />
      </span>
    )
  }

  // Fill 4 slots by cycling through available urls
  const cells = [0, 1, 2, 3].map(i => urls[i % urls.length])

  return (
    <span className={styles.mosaic} style={mosaicStyle}>
      {cells.map((url, i) => (
        <span
          key={i}
          className={styles.mosaicCell}
          style={{ backgroundImage: `url("${url}")` }}
        />
      ))}
    </span>
  )
}

export default PlaylistMosaic
